import styled from "styled-components";
import { ColorKey } from "@template/theme/types/color.type.ts";

export const CtaLink = styled.div<{ $color: ColorKey }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${(props) => props.theme.colors[props.$color].default};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
`;
